import type { SVGProps } from "react";

export default function ModifiedIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
        stroke="#FF790C"
        strokeWidth="1.25528"
      />
      <path
        d="M6.66699 14.1667H13.3337"
        stroke="#FF790C"
        strokeLinecap="round"
      />
      <path
        d="M10.787 6.52638L11.096 6.21742C11.6079 5.70552 12.4378 5.70552 12.9497 6.21742C13.4616 6.72933 13.4616 7.55928 12.9497 8.07118L12.6408 8.38014M10.787 6.52638C10.787 6.52638 10.8256 7.18292 11.405 7.76222C11.9842 8.34152 12.6408 8.38014 12.6408 8.38014M10.787 6.52638L7.9466 9.36679C7.75421 9.55916 7.65802 9.65537 7.57529 9.76145C7.47771 9.88654 7.39404 10.0219 7.32577 10.1652C7.26791 10.2866 7.22488 10.4157 7.13885 10.6738L6.77426 11.7675M12.6408 8.38014L9.80037 11.2205C9.60799 11.413 9.51178 11.5091 9.4057 11.5919C9.28062 11.6895 9.14522 11.7731 9.00198 11.8414C8.88056 11.8992 8.7515 11.9423 8.49338 12.0283L7.39963 12.3929M6.77426 11.7675L6.68514 12.0349C6.6428 12.1619 6.67586 12.302 6.77053 12.3966C6.86521 12.4913 7.00525 12.5244 7.13227 12.482L7.39963 12.3929M6.77426 11.7675L7.39963 12.3929"
        stroke="#FF790C"
      />
    </svg>
  );
}
